/**
 * Derives the transfer's encoded id from a share URL's last path segment. Per API contract v3 the
 * encoded id in `/download/{encodedId}` IS what the anonymous `GET /transfers/{id}/stats` takes and
 * what `POST /transfer/uploads/{transferId}/email` decodes, so deriving it from the URL is a single
 * source of truth that works for BOTH modes — the instant registration never returns a transfer id at
 * all, only the URL. (Chosen over threading `transferId` through the service result.)
 *
 * This module used to also own `useDownloadStats`, the 5-second poll behind the success card's live
 * DOWNLOADS tile. ui#1655 removed that tile, which left the hook with no caller.
 */
export function statsIdFromShareUrl(url: string): string | null {
	const path = url.split(/[?#]/)[0];
	const segments = path.split("/").filter(Boolean);
	return segments.length ? segments[segments.length - 1] : null;
}
